import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../components/ErrorMessage";

const FaqUpdateCard = ({ faq, schema, onUpdate, onDelete }) => {
  const { id, questionEn, answerEn } = faq;

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    initialValue: faq,
  });

  const onSubmit = (data) => {
    onUpdate(data, id);
  };

  useEffect(() => {
    setValue("questionEn", questionEn);
    setValue("answerEn", answerEn);
  }, []);

  return (
    <div className="custom-card">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form__div-container">
          <div className="form__div">
            <input
              type="text"
              className="form__input"
              {...register("questionEn")}
            />
            <label htmlFor="" className="form__label">
              Question
            </label>
          </div>
          <ErrorMessage message={errors?.questionEn?.message} />
        </div>
        <div className="mb-2">
          <div className="form__div--textarea mb-0">
            <textarea
              className="form__textarea"
              rows="7"
              {...register("answerEn")}
            />
            <label htmlFor="" className="textarea-form__label">
              Answer
            </label>
          </div>
          <ErrorMessage message={errors?.answerEn?.message} />
        </div>
        <div className="text-right mt-4">
          <button
            type="button"
            onClick={() => onDelete(id)}
            className="delete-btn"
          >
            Delete
          </button>
          <button type="submit" className="save-btn ml-2">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default FaqUpdateCard;
